import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    categoryPathPrefix = "categoryPathPrefix",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.categoryPathPrefix]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const pagination = getProductListDataViewProperty(state, "pagination");

    return {
        totalItemCount: pagination?.totalItemCount,
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasCategoryContext;

export interface ClearanceProductCountStyles {
    wrapper?: InjectableCss;
    resultsText?: TypographyPresentationProps;
}

export const clearanceProductCountStyles: ClearanceProductCountStyles = {
    wrapper: {
        css: css`
            margin: 10px 0;
        `,
    },
    resultsText: {
        css: css`
            font-size: 19px;
            font-weight: 700;
            line-height: 2;
            color: #000;
        `,
    },
};

const styles = clearanceProductCountStyles;

const ClearanceProductCount: FC<Props> = ({ totalItemCount, category, fields }) => {
    if (totalItemCount === undefined || totalItemCount === null) {
        return null;
    }

    const categoryName = category?.shortDescription || category?.name || "";
    const pathPrefix = fields.categoryPathPrefix || "Shop by Category";
    const categoryPath = categoryName ? `${pathPrefix} > ${categoryName}` : pathPrefix;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.resultsText} data-test-selector="clearanceProductCountText">
                {`${totalItemCount} Results found for '${categoryPath}'`}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(ClearanceProductCount)),
    definition: {
        group: "Product List",
        displayName: "Clearance Product Count",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.categoryPathPrefix,
                displayName: "Category Path Prefix",
                editorTemplate: "TextField",
                defaultValue: "Shop by Category",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
